import { useContext } from 'react';

import { FeatureContext } from '../contexts/feature-flag.context';

export function useFeatureFlags() {
  return useContext(FeatureContext);
}
